var buttonMotionData = {
  name: 'buttonMotion',
  data: [{
    motion: 'shake'
  }, {
    motion: ''
  } // 无动画
  ]
};

var allAnimations = [buttonMotionData];
export default allAnimations;